import { createIcon, IconProps } from "@chakra-ui/react";

type IconSize = "sm" | "md" | "lg";

interface CloudOfflineIconProps extends IconProps {
    size?: IconSize;
}

const BaseCloudOfflineIcon = createIcon({
    displayName: "CloudOfflineIcon",
    viewBox: "0 0 24 24",
    defaultProps: {
        fill: "none",
        stroke: "currentColor"
    },
    path: (
        <>
            <g clipPath="url(#clip)">
                <path
                    // eslint-disable-next-line max-len
                    d="M22.61 16.95A4.999 4.999 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3M1 1l22 22"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </>
    )
});

export const CloudOfflineIcon = ({ size = "md", ...props }: CloudOfflineIconProps) => {
    const boxSizeMap: Record<IconSize, string> = {
        sm: "4",
        md: "6",
        lg: "8"
    };

    return <BaseCloudOfflineIcon boxSize={boxSizeMap[size]} {...props} />;
};
